import { FrameType, type TourFrame } from '@carboncopyco/types';
import { useMemo } from 'react';

export const useIsAnyFrameScreenshot = (frames: TourFrame[]) =>
  useMemo(
    () => frames.some((frame) => frame.frameType === FrameType.screenshot),
    [frames]
  );
